
import { formatPrice } from "@/utils/tripFormatUtils";

interface TripPriceDisplayProps {
  date: string;
  price: number | string;
  isCompleted: boolean;
}

const TripPriceDisplay = ({ date, price, isCompleted }: TripPriceDisplayProps) => {
  const formattedPrice = formatPrice(price);
  
  return (
    <>
      <h3 className={`text-2xl font-bold mb-3 ${isCompleted ? 'text-white' : 'text-black'}`}>
        {isCompleted ? `${date.split(' - ')[0]}` : date}
      </h3>
      
      <div className={`${isCompleted ? 'bg-white text-black' : 'bg-black text-white'} rounded-md py-1 px-2 inline-flex items-center gap-1 mb-3`}>
        <span className={isCompleted ? 'text-black' : 'text-neon-green'}>
          {isCompleted ? 'Payout:' : 'Est Payout:'}
        </span>
        <span className={isCompleted ? 'text-black' : 'text-white'}>
          ${formattedPrice}
        </span>
      </div>
    </>
  );
};

export default TripPriceDisplay;
